import { GraphUtils } from '@helpers/graph.helper';
import { Sensor, dataChart } from './sensor';
import { Router } from '@angular/router';

export class NpkSensor extends Sensor {
  public nitrogenChart: any;
  public phosphorusChart: any;
  public potassiumChart: any;

  private nitrogenSensor: any[];
  private phosphorusSensor: any[];
  private potassiumSensor: any[];

  constructor(router: Router, url: string, alerstActive: boolean) {
    super(router, url, alerstActive);
    this.nitrogenChart = null;
    this.phosphorusChart = null;
    this.potassiumChart = null;

    this.nitrogenSensor = [[], [], []];
    this.phosphorusSensor = [[], [], []];
    this.potassiumSensor = [[], [], []];
  }

  public hasNitSensor(pos: number): boolean {
    return this.nitrogenSensor[pos - 1].length > 0;
  }

  public getNitSensor(pos: number): any {
    const realPos: number = this.nitrogenSensor[pos - 1].length - 1;
    return this.nitrogenSensor[pos - 1][realPos][1] ?? null;
  }

  public hasPhosSensor(pos: number): boolean {
    return this.phosphorusSensor[pos - 1].length > 0;
  }

  public getPhosSensor(pos: number): any {
    const realPos: number = this.phosphorusSensor[pos - 1].length - 1;
    return this.phosphorusSensor[pos - 1][realPos][1] ?? null;
  }

  public hasPotSensor(pos: number): boolean {
    return this.potassiumSensor[pos - 1].length > 0;
  }

  public getPotSensor(pos: number): any {
    const realPos: number = this.potassiumSensor[pos - 1].length - 1;
    return this.potassiumSensor[pos - 1][realPos][1] ?? null;
  }

  public prepareData(): void {
    for (const element of this.data) {
      const date = new Date(element.date);
      this.nitrogenSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.nitrogen,
      ]);

      this.phosphorusSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.phosphorus,
      ]);

      this.potassiumSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.potassium,
      ]);
    }
  }

  public setCharts(): void {
    this.nitrogenChart = this.getConfigChar(
      'nitrogenChart',
      this.getChartSeries('Nit', this.nitrogenSensor),
      this.getRanges('11_nitrogen'),
      this.getLimits('11_nitrogen')
    );
    this.potassiumChart = this.getConfigChar(
      'potassiumChart',
      this.getChartSeries('Pot',
      this.potassiumSensor),
      this.getRanges('11_potassium'),
      this.getLimits('11_potassium')
    );
    this.phosphorusChart = this.getConfigChar(
      'phosphorusChart',
      this.getChartSeries('Pho', this.phosphorusSensor),
      this.getRanges('11_phosphorus'),
      this.getLimits('11_phosphorus')
    );
  }

  public static getVariables(): any[] {
    return [
      { title: 'Nitrógeno', value: '11_nitrogen' },
      { title: 'Fósforo', value: '11_phosphorus' },
      { title: 'Potasio', value: '11_potassium' }
    ];
  }
}